/** 갱신에 실패해도 기존 데이터를 표시할 수 있는 조회 쿼리에만 명시적으로 적용한다. */
export const PRESERVE_CACHED_DATA_META = {
  globalErrorPolicy: "preserve-cached-data",
} as const

type QueryErrorContext = {
  meta?: Record<string, unknown>
  state: { data: unknown }
}

export const shouldPreserveCachedQueryData = ({ meta, state }: QueryErrorContext): boolean =>
  meta?.globalErrorPolicy === PRESERVE_CACHED_DATA_META.globalErrorPolicy &&
  // 관찰자의 placeholder 데이터나 다른 키가 아닌, 실패한 쿼리 자체의 캐시를 확인한다.
  state.data !== undefined
